const VIEW_OPTIONS = {
  "/supplier-pos": { key: "tab", values: ["bom", "cons", "unclassified"], defaultValue: "bom" },
  "/cost-allocations": { key: "view", values: ["workbench", "register"], defaultValue: "workbench" },
};

export const isNavigationActive = (location, target) => {
  const [path, search = ""] = target.split("?");
  const currentPath = location.pathname.replace(/\/+$/, "") || "/";
  if (currentPath !== path) return false;
  const expected = new URLSearchParams(search);
  const actual = new URLSearchParams(location.search);
  const options = VIEW_OPTIONS[path];
  if (options) {
    const value = actual.get(options.key);
    actual.set(options.key, options.values.includes(value) ? value : options.defaultValue);
  }
  return [...expected].every(([key, value]) => actual.get(key) === value);
};